import { axiosInstance } from '@/lib/utils';
import { endpoints } from '@/api';
import type {
  RequestResponse,
  OmnichannelAccount,
  PaginatedConversationsResponse,
  PaginatedMessagesResponse,
  ChannelType,
} from '@/types';

export const fetchOmnichannelStatus = async () => {
  const response = await axiosInstance<RequestResponse<unknown>>(
    endpoints.omnichannel.status
  );
  return response.data.data as {
    facebook?: boolean | { pageId?: string };
    instagram?: boolean | { pageId?: string };
    whatsapp?: boolean | { pageId?: string };
  };
};

export const fetchOmnichannelAccounts = async (params: {
  channel: ChannelType;
}) => {
  const response = await axiosInstance<RequestResponse<OmnichannelAccount[]>>(
    endpoints.omnichannel.accounts,
    {
      params: {
        channel: params.channel,
      },
    }
  );
  return Array.isArray(response.data.data) ? response.data.data : [];
};

// Fetch conversations for a specific channel
export const fetchOmnichannelConversations = async (params: {
  channel: ChannelType;
  pageId?: string;
  page?: number;
}) => {
  const response = await axiosInstance<
    RequestResponse<PaginatedConversationsResponse>
  >(endpoints.omnichannel.conversations, {
    params: {
      channel: params.channel,
      ...(params.pageId && { pageId: params.pageId }),
      ...(params.page && { page: params.page }),
    },
  });
  const data = response.data.data;
  return data
    ? {
        ...data,
        data: Array.isArray(data.data) ? data.data : [],
      }
    : {
        nextPage: 1,
        currentPage: 1,
        lastPage: 1,
        currentPagesize: 0,
        total: 0,
        data: [],
      };
};

// Fetch messages for a specific conversation
export const fetchConversationMessages = async (
  conversationId: string,
  params: {
    channel: ChannelType;
    pageId?: string;
    page?: number;
  }
) => {
  const response = await axiosInstance<
    RequestResponse<PaginatedMessagesResponse>
  >(`${endpoints.omnichannel.conversations}/${conversationId}/messages`, {
    params: {
      channel: params.channel,
      ...(params.pageId && { pageId: params.pageId }),
      ...(params.page && { page: params.page }),
    },
  });
  const data = response.data.data;
  return data
    ? {
        ...data,
        data: Array.isArray(data.data) ? data.data : [],
      }
    : {
        nextPage: 1,
        currentPage: 1,
        lastPage: 1,
        currentPagesize: 0,
        total: 0,
        data: [],
      };
};
